import { Icon, Input, InputGroup, InputRightElement } from "@chakra-ui/react"
import debounce from "lodash.debounce"
import React, { ChangeEvent, ReactElement, useCallback, useRef, useState } from "react"
import { suggestDefaults } from "../../../../../../../common/constants/suggest-constants"
import { FhResponseData } from "../../../../../../../common/types/search"
import { CClose, CSearch } from "../../../../../../shared/Icons"

type Props = {
  isSearchEnabled: boolean
  filteredFiltersection: FhResponseData
  children: ReactElement | never
}

const TypeHeadSearch = (props: Props) => {
  const { isSearchEnabled, filteredFiltersection, children } = props
  const [searchFiltersection, setSearchFiltersection] = useState(filteredFiltersection)

  const filterSearchFieldRef = useRef(null)
  const hasValue = !!filterSearchFieldRef?.current?.value

  const filterFilterSection = (inputValue: string) => {
    const filtered = filteredFiltersection.filter((filter: FhResponseData) => {
      const lowerCaseName = filter.link.name.toLowerCase()

      return lowerCaseName.includes(inputValue.toLowerCase())
    })

    setSearchFiltersection(filtered)
  }

  const handleChange = useCallback(
    debounce(
      (e: ChangeEvent<HTMLInputElement>) => filterFilterSection(e.target.value),
      suggestDefaults.SUGGEST_QUERY_TIMEOUT
    ),
    []
  )

  const handleCloseIconClick = () => {
    filterSearchFieldRef.current.value = ""
    filterSearchFieldRef.current.focus()
    setSearchFiltersection(filteredFiltersection)
  }

  const handleSearchIconClick = () => {
    filterSearchFieldRef.current.focus()
  }

  if (isSearchEnabled) {
    return (
      <>
        <InputGroup
          variant="flushed"
          bg="gray.200"
          color="black"
          mb={{ base: "4", sm: "6", md: "2" }}
          mx={{ base: "4", sm: "6", md: "2" }}
          w="auto"
        >
          <InputRightElement
            // eslint-disable-next-line react/no-children-prop
            children={
              <Icon
                as={hasValue ? CClose : CSearch}
                w="5"
                h="5"
                cursor="pointer"
                onClick={hasValue ? handleCloseIconClick : handleSearchIconClick}
              />
            }
          />
          <Input
            pl="2"
            h={{ base: "11", md: "10" }}
            fontSize="sm"
            onChange={handleChange}
            ref={filterSearchFieldRef}
            _focusVisible={{}}
          />
        </InputGroup>
        {React.cloneElement(children, { ...props, searchFiltersection })}
      </>
    )
  }

  return children
}

export default TypeHeadSearch
